import Vue from 'vue'
import App from './App.vue'
import '@fontsource/noto-sans-sc/chinese-simplified-400.css'
import '@fontsource/noto-sans-sc/chinese-simplified-700.css'

Vue.config.productionTip = false

// 抑制 ResizeObserver loop 良性错误（浏览器在字体加载/CSS动画期间常见，不影响功能）
window.addEventListener('error', (event) => {
  if (event.message && event.message.includes('ResizeObserver loop')) {
    event.preventDefault()
  }
})

new Vue({
  render: h => h(App),
}).$mount('#app')
